import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  gap: 1rem;
`;

export default Container;
